export const INDUSTRIES_CALL = "INDUSTRIES_CALL";

export function callIndustries() {
  return { type: INDUSTRIES_CALL };
}
